var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoAssembleiasAcionistas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-assembleias-acionistas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestao-assembleias-acionistas_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.4,74.3h-16.7l10.2-5.9c0.9-0.5,1.6-1.4,1.9-2.5c0.3-1.1,0.1-2.2-0.4-3.1l-21.2-36.3 c-1.1-1.9-3.6-2.6-5.5-1.5L49.3,60c-0.9,0.5-1.6,1.4-1.9,2.5c-0.3,1.1-0.1,2.2,0.4,3.1l5.1,8.8H28.6c-2.2,0-4.1,1.8-4.1,4.1v64 c0,2.2,1.8,4.1,4.1,4.1h113.7c2.2,0,4.1-1.8,4.1-4.1v-64C146.4,76.2,144.6,74.3,142.4,74.3z M138.3,110.8v27.5H32.7v-27.5H138.3z  M70.4,88.5L56.9,65.1l54.3-30.9l17.1,29.3l-43.4,25H70.4z M46,88.5v8.1h79v-8.1h-23.8l10.4-6h26.7v20.2H32.7V82.5h24.8l3.5,6H46z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,46.2c-1-0.3-2.1-0.3-3.1,0.2s-1.7,1.3-2,2.4l-5,15l-2.4-2.4c-1.5-1.5-4.2-1.5-5.8,0 c-1.6,1.6-1.6,4.2,0,5.8l7.1,7.1c0.8,0.8,1.8,1.2,2.9,1.2c0.3,0,0.6,0,0.9-0.1c1.4-0.3,2.5-1.3,2.9-2.7l7.1-21.2 c0.3-1,0.3-2.1-0.2-3.1C102.8,47.3,102,46.6,100.9,46.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoAssembleiasAcionistas);
export default __webpack_public_path__ + "static/media/gestao-assembleias-acionistas.b35a1ee593dfc26c4206cf8cc033d6ae.svg";
export { ForwardRef as ReactComponent };